import { render, staticRenderFns } from "./AdminStat.vue?vue&type=template&id=ea99a2b2&"
import script from "./AdminStat.vue?vue&type=script&lang=ts&"
export * from "./AdminStat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports